/**
 * Product Description Route
 */
import React, { useLayoutEffect } from 'react';
import Layout from '@/components/Layout';
import ProductDescription from '../../../containers/ProductDescription';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import { _404Redirect } from '@/utils/404Redirect';
import { useSetSSRStore, useSSRSelector } from '../../../redux';
import { getSSRStoreData } from '../../../utils/ssrPageData';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';
import { pushFeatureLockCollectiveData } from 'src/utils/hack.featureLocks';
import { getCatalogItemBySlug } from 'src/services/catalog';
import { handlePDPErrorCaseRedirection } from 'src/utils/productUtils';
import { fetchAdditionalPageSeoDetails } from 'src/utils/fetchAdditionalPageSeoDetails';

const ProductDescPage = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout
      store={storeInfo}
      title={
        props?.advCustomSeoDetails?.title?.value
          ? props?.advCustomSeoDetails?.title?.value
          : `Order ${props?.product?.name} Online From ${storeInfo?.store_info?.name}${
              storeInfo?.address?.visibility === 1 && storeInfo.address?.city
                ? `,${storeInfo.address?.city}`
                : ``
            }`
      }
      OGTitle={props?.advCustomSeoDetails?.og_title?.value || null}
      OGDescription={props?.advCustomSeoDetails?.og_description || null}
      Icon={props?.product?.thumbnail_url}
      metaDescription={
        props?.advCustomSeoDetails?.description
          ? props?.advCustomSeoDetails?.description
          : `Order Online ${props?.product?.name} for Rs.${props?.product?.price}. Shop from ${storeInfo?.store_info?.name},${storeInfo.address?.city} | ${props?.product?.description}`
      }
      isCustomDomain={props.isCustomDomain}
      {...props}
    >
      <ProductDescription {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};
  const { pid } = ctx.query;
  let propData = {
    product: {},
    catalogCategories: [],
    isCustomDomain: false,
    catalogTags: [],
    collections: [],
    advCustomSeoDetails: {},
  };

  const propType = await getSSRStoreData(ctx, {
    additionalDataToFetch: ['collections', 'categories'],
  });

  /**
   * This was a hack, to retry fetching the required SSR data if it is not there.
   * discuss with respective devs before making any changes here or reordering this peice of code.
   */
  await pushFeatureLockCollectiveData({
    storeInfo: propType?.ssrStore?.storeReducer?.store,
    additionalDataToFetch: ['collections', 'categories'],
    propType,
    ctx,
  });

  const storeId = propType?.ssrStore?.storeReducer?.store?.store_id;

  if (!storeId) {
    _404Redirect(ctx, 302);
    ctx.res.end();
    return { props: {} };
  }

  const productResponse = await getCatalogItemBySlug(storeId, pid);
  if (productResponse.data && productResponse.data.status) {
    const productItem = JSON.parse(productResponse?.data?.data);
    propData.product = productItem;

    // fetch advance seo data after fetching product data
    const storeInfo = propType.ssrStore.storeReducer.store;
    propData.advCustomSeoDetails = await fetchAdditionalPageSeoDetails({
      type: 'item',
      typeId: productItem?.id,
      storeInfo,
    });
  } else {
    handlePDPErrorCaseRedirection({ ctx, productResponse, propType });
    return { props: {} };
  }

  const extraProps = getRequiredCtxProps(ctx, propType);

  propData = { ...propData, ...propType };

  return { props: { ...propData, ...extraProps } };
}

export default ProductDescPage;
